import BearSvg from "@/assets/svg/BearSvg";
import BullSvg from "@/assets/svg/BullSvg";
import HeartSvg from "@/assets/svg/HeartSvg";
import LightningSvg from "@/assets/svg/LightningSvg";
import ReactionsModal from "@/components/UI/modal/ReactionsModal/ReactionsModal";
import { formatMoney } from "@/helpers/formatMoney";
import { normalizeSentiment } from "@/helpers/normalizeSentiment";
import { IPost } from "@/store/api/postApiData";
import theme from "@/theme";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { FC, useState } from "react";

interface IPostFooterProps {
  lastThreeLike?: string[];
  post: IPost;
  zapsCountState: number;
  isLikedTemporary: boolean;
  totalZapsAmountState: number;
  totalLikesAmount?: number;
}

const PostFooter: FC<IPostFooterProps> = ({
  post,
  zapsCountState,
  isLikedTemporary,
  totalZapsAmountState,
  lastThreeLike,
  totalLikesAmount,
}) => {
  const LIKE_PRICE = totalLikesAmount || 0;

  const [activeTab, setActiveTab] = useState<"likes" | "zaps">();
  const [reactionsModalOpen, setReactionsModalOpen] = useState(false);

  const displayedLikes = post.likesCount + (isLikedTemporary && !post.isLiked ? 1 : 0);
  const displayedAvatars = [...new Set(lastThreeLike || post.reactionsPreview || [])];
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      justifyContent={"space-between"}
      sx={{
        height: "24px",
        marginTop: "16px",
        width: "100%",
      }}
    >
      <ReactionsModal
        postId={post.uid}
        open={reactionsModalOpen}
        onClose={() => setReactionsModalOpen(false)}
        likesCount={displayedLikes || 0}
        zapsCount={zapsCountState || 0}
        initialTab={activeTab}
      />

      <Stack
        direction="row"
        alignItems="center"
        gap="6px"
        sx={{
          height: "24px",
          opacity: 1,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          gap="4px"
          sx={{
            height: "24px",
            borderRadius: "20px",
            padding: "0 6px 0 4px",
            background: "#F4F5F6",
            cursor: "pointer",
          }}
          onClick={() => {
            setReactionsModalOpen(true);
            setActiveTab("zaps");
          }}
        >
          <LightningSvg width={18} height={18} />

          <Stack direction="row" gap="2px" alignItems="center" sx={{ justifyContent: "center" }}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "10px",
                color: "#000000",
                alignItems: "center",
              }}
            >
              {formatMoney(totalZapsAmountState)} USDC
            </Typography>
            {/* {zapsCountState > 0 && (
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "10px",
                  color: "#9DA6B0",
                }}
              >
                {isLoading
                  ? "(loading...)"
                  : `(≈$${(Number(SATSprice?.result) * totalZapsAmountState).toFixed(2)} USD)`}
              </Typography>
            )} */}
          </Stack>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          gap="4px"
          sx={{
            height: "26px",
            borderRadius: "20px",
            padding: "0 6px 0 4px",
            background: "#F4F5F6",
            cursor: "pointer",
          }}
          onClick={() => {
            setReactionsModalOpen(true);
            setActiveTab("likes");
          }}
        >
          <HeartSvg
            style={{
              width: "18px",
              height: "18px",
              flexShrink: 0,
            }}
          />

          <Stack direction="row" gap="2px" alignItems="center" sx={{ justifyContent: "center" }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "10px",
                color: "#000000",
              }}
            >
              {formatMoney(LIKE_PRICE)} USDC
            </Typography>
            {displayedLikes > 0 && (
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "10px",
                  color: "#9DA6B0",
                }}
              >
                {/* {isLoading
                  ? "(loading...)"
                  : `(≈$${(Number(SATSprice?.result) * displayedLikes * LIKE_PRICE).toFixed(
                      2
                    )} USD)`} */}
              </Typography>
            )}
          </Stack>
        </Stack>

        {post?.subtypes?.length > 0 && (
          <Box display="flex" flexDirection="column" alignItems="center">
            <Stack
              direction="row"
              alignItems="center"
              gap="4px"
              sx={{
                padding: "0 6px 0 4px",
                height: "26px",
                borderRadius: "20px",
                background: "#F4F5F6",
                cursor: "pointer",
                justifyContent: "center",
              }}
            >
              {post?.topic === "STOCKS" && (
                <Typography
                  sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                  color={
                    normalizeSentiment(post?.sentiment) === 0
                      ? theme.palette.custom.blueGray600
                      : normalizeSentiment(post?.sentiment) <= 0
                        ? theme.palette.custom.secondaryRed
                        : theme.palette.custom.secondaryGreen
                  }
                >
                  {normalizeSentiment(post?.sentiment) === 0
                    ? "0"
                    : normalizeSentiment(post?.sentiment) < 0
                      ? `-${Math.abs(normalizeSentiment(post?.sentiment))}`
                      : `+${normalizeSentiment(post?.sentiment)}`}{" "}
                  {normalizeSentiment(post?.sentiment) === 0 ? (
                    ""
                  ) : normalizeSentiment(post?.sentiment) <= 0 ? (
                    <BearSvg width={27} height={14} />
                  ) : (
                    <BullSvg width={27} height={14} />
                  )}
                </Typography>
              )}

              <Stack
                direction="row"
                gap="2px"
                alignItems="center"
                sx={{
                  justifyContent: "center",
                  marginLeft: normalizeSentiment(post?.sentiment) !== 0 ? "4px" : 0,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "10px",
                    color: "#000000",
                  }}
                >
                  {post?.subtypes?.map((item: string) => "#" + item.toLowerCase()).join(" ")}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        )}
      </Stack>

      <Stack
        direction="row"
        onClick={() => {
          setReactionsModalOpen(true);
          setActiveTab("likes");
        }}
      >
        {Array.from({ length: 3 }).map((_, index) => {
          const item = displayedAvatars[index];
          return (
            <Avatar
              key={index}
              src={item || ""}
              alt="Profile"
              sx={{
                width: 24,
                height: 24,
                marginRight: index === 2 ? 0 : "-0.5rem",
                border: "1px solid #9DA6B0",
                backgroundColor: item ? "#fff" : "#E0E0E0",
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default PostFooter;
